
import HypothesisDetailContainer from 'containers/HypothesisDetailContainer';

export default (props: any) => (
  <HypothesisDetailContainer {...props} create={true} />
);
